/* DeviceStatusRenderer.js */

"use strict";

class DeviceStatusRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("devicestatus-column");
        this._rootElem.component = this._model;

        this._onDeviceStatus = this._onDeviceStatus.bind(this);
        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._unregisterListeners();

        return new Promise((resolve /*,reject*/) => {
            this._rootElem.remove();
            this._rootElem = undefined;
            this._model = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("DeviceStatus", this._onDeviceStatus);
    }

    _unregisterListeners() {
        this._model.removeAllListeners("DeviceStatus");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            this._setDeviceStatus(this._model.getValue(), this._model.getDeviceStatusTitle());
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDeviceStatus(status, title) {
        this._setDeviceStatus(status, title);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setDeviceStatus(status, title = "") {
        if (status) {
            this._rootElem.innerHTML = status;
            this._rootElem.title = title;
        } else {
            this._rootElem.innerHTML = "";
            this._rootElem.title = title;
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = DeviceStatusRenderer;
